import React from 'react';
import { MobileSelect } from '../ui/MobileSelect';

interface DrillAlertSettingsSectionProps {
  forceUpdate: () => void;
}

export const DrillAlertSettingsSection: React.FC<DrillAlertSettingsSectionProps> = ({
  forceUpdate
}) => {
  const audioFiles = [
    { label: 'Referee Whistle', file: '/assets/audio/referee-whistle-blow-gymnasium-6320.mp3' },
    { label: 'Generic Alarm Clock', file: '/assets/audio/generic-alarm-clock-86759.mp3' },
    { label: 'Clock Alarm', file: '/assets/audio/clock-alarm-8761.mp3' },
    { label: 'Notification Alert 7', file: '/assets/audio/notification-alert-7-331719.mp3' },
    { label: 'Notification Alert 4', file: '/assets/audio/notification-alert-4-331722.mp3' },
    { label: 'Notification Ping', file: '/assets/audio/notification-ping-335500.mp3' },
    { label: 'Air Horn', file: '/assets/audio/air-horn-273892.mp3' },
  ];

  const playSound = (soundFile: string) => {
    const audio = new Audio(soundFile);
    audio.play().catch(error => {
      console.error('Error playing sound:', error);
    });
  };

  return (
    <div className="space-y-3">
      <div>
        <label className="form-label">Warning Interval (minutes before drill ends)</label>
        <MobileSelect
          value={localStorage.getItem('warningInterval') || '2'}
          onChange={(v) => { localStorage.setItem('warningInterval', v); forceUpdate(); }}
          options={[1, 2, 3, 4, 5].map(val => ({
            value: String(val),
            label: `${val} minute${val > 1 ? 's' : ''}`,
          }))}
          className="w-full p-2 border border-stone rounded mb-4"
          aria-label="Warning Interval"
          sheetTitle="Warning Interval"
        />
      </div>

      <div>
        <label className="form-label">Warning Sound</label>
        <MobileSelect
          value={localStorage.getItem('warningSound') || '/assets/audio/notification-alert-7-331719.mp3'}
          onChange={(v) => { localStorage.setItem('warningSound', v); forceUpdate(); }}
          options={audioFiles.map(opt => ({ value: opt.file, label: opt.label }))}
          className="w-full p-2 border border-stone rounded mb-4"
          aria-label="Warning Sound"
          sheetTitle="Warning Sound"
        />
        <button
          type="button"
          className="btn-secondary mb-2"
          onClick={() => playSound(localStorage.getItem('warningSound') || '/assets/audio/notification-alert-7-331719.mp3')}
        >
          Preview Warning Sound
        </button>
      </div>

      <div>
        <label className="form-label">Drill End Sound</label>
        <MobileSelect
          value={localStorage.getItem('drillEndSound') || '/assets/audio/air-horn-273892.mp3'}
          onChange={(v) => { localStorage.setItem('drillEndSound', v); forceUpdate(); }}
          options={audioFiles.map(opt => ({ value: opt.file, label: opt.label }))}
          className="w-full p-2 border border-stone rounded mb-4"
          aria-label="Drill End Sound"
          sheetTitle="Drill End Sound"
        />
        <button
          type="button"
          className="btn-secondary mb-2"
          onClick={() => playSound(localStorage.getItem('drillEndSound') || '/assets/audio/air-horn-273892.mp3')}
        >
          Preview Drill End Sound
        </button>
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          id="mute-sound"
          checked={localStorage.getItem('drillSoundMuted') === 'true'}
          onChange={e => {
            localStorage.setItem('drillSoundMuted', String(e.target.checked));
            forceUpdate();
          }}
        />
        <label htmlFor="mute-sound" className="text-sm">Mute sound notifications</label>
      </div>
    </div>
  );
};
